<div class="main-banner-white-service pb-70" style="height:auto">
    <div class=" pt-70 texto-centrado-h1" style="padding-left: 23%;padding-right: 23%;">
        <!-- Document content -->
        <div class="document-container" style="width: 100%; max-height: 80vh; overflow-y: auto; padding: 20px; padding-top: 60px; background-color: white;">
            <div class="document-content" style="white-space: pre-line; line-height: 1.8; font-family: Arial, sans-serif; font-size: 14px; color: #333;" 
                 [innerHTML]="getFormattedDocumentContent()">
            </div>
            
            <!-- Fallback message if no content -->
            <div class="text-center p-5" *ngIf="!getDocumentContent()">
                <p class="texto-negro">Documento no disponible para esta sección e idioma.</p>
                <p class="texto-negro">Por favor, contacte con el administrador.</p>
            </div>
        </div>
    </div>
</div>